import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Video, VideoOff } from 'lucide-react';
import { AppButton } from '../../../ui';
import { isOnlineBatch } from '../trainerDashboardUtils';

/**
 * ClassControl — the live-class buttons for one batch.
 *
 *   smart-learning batch, not live → Smart session (it never shows Start class)
 *   live online batch              → Rejoin + End
 *   online batch                   → Start class
 *   offline batch                  → nothing
 *
 * Rejoin is a real link to the classroom and a FULL page load, not a router
 * push: the meeting SDKs boot once per document.
 *
 * Props:
 *   batch    — a batch row from the dashboard summary
 *   onStart  — (batch) => void; the page runs the pre-meeting check
 *   onEnd    — (batch) => void; the page confirms first
 *   emphasis — true on the one class the trainer should act on now. Every other
 *              row gets an outline button, so a list of batches does not read
 *              as a wall of equally urgent calls to action.
 */
const ClassControl = ({ batch, onStart, onEnd, emphasis = false }) => {
  if (!batch) return null;
  const variant = emphasis ? 'default' : 'outline';

  if (batch.smartLearningEnabled && !batch.isLive) {
    return (
      <AppButton as={Link} to={`/i/batch/${batch._id}?tab=smart-sessions`} size="sm" variant={variant}>
        <Sparkles size={16} aria-hidden="true" /> Smart session
      </AppButton>
    );
  }

  if (batch.isLive && isOnlineBatch(batch)) {
    return (
      <>
        <AppButton as="a" href={`/i/classroom/${batch._id}`} size="sm">
          <Video size={16} aria-hidden="true" /> Rejoin
        </AppButton>
        <AppButton
          size="sm"
          variant="outline-destructive"
          onClick={() => onEnd(batch)}
          aria-label={`End the class for ${batch.name}`}
        >
          <VideoOff size={16} aria-hidden="true" /> End
        </AppButton>
      </>
    );
  }

  if (isOnlineBatch(batch)) {
    return (
      <AppButton size="sm" variant={variant} onClick={() => onStart(batch)}>
        <Video size={16} aria-hidden="true" /> Start class
      </AppButton>
    );
  }

  return null;
};

export default ClassControl;
